module.exports = __webpack_public_path__ + "static/case_img1-5e726453a829010b7699baf3a3c01fa5.png";